import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

// Polls reminders and shows a toast at most once per case per session.
export default function ReminderNotifier() {
  const { user } = useAuth();
  const shown = useRef(new Set());
  const nav = useNavigate();

  useEffect(() => {
    if (!user) return;
    // hydrate from sessionStorage
    try {
      const raw = sessionStorage.getItem("phr_reminders_shown");
      if (raw) shown.current = new Set(JSON.parse(raw));
    } catch {}

    let cancelled = false;
    const check = async () => {
      try {
        const r = await api.get("/reminders");
        if (cancelled) return;
        (r.data.reminders || []).forEach((rem) => {
          if (shown.current.has(rem.case_id)) return;
          shown.current.add(rem.case_id);
          try { sessionStorage.setItem("phr_reminders_shown", JSON.stringify([...shown.current])); } catch {}
          toast(`Time to send Message ${rem.next_message_num} on ${rem.merchant_name}`, {
            description: `${rem.hours_since_sent}h since your last message.`,
            duration: 8000,
            action: {
              label: "Open case",
              onClick: () => nav(`/case/${rem.case_id}`),
            },
          });
        });
      } catch {}
    };
    check();
    const t = setInterval(check, 60_000);
    return () => { cancelled = true; clearInterval(t); };
  }, [user, nav]);

  return null;
}
